module.exports = __webpack_public_path__ + "static/media/other.26446a77.svg";